import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const SectionContainer = styled.section`
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 2px 4px 4px 0 rgba(0, 0, 0, 0.25);
  margin-bottom: 1.25rem;
  width: 100%;
`;

export const DocumentOuter = styled.div`
  padding: 10px;
`;

export const FileInputLabel = styled.label`
  width: auto;
  color: #1bace4;
  font-family: "Lato";
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
  text-align: center;
  text-align: left;
`;

export const DocumentRow = styled.div`
  padding-left: 10px;
  margin-top: 15px;
`;

export const FileName = styled.p`
  line-height: 2;
  color: #084987;
  position: absolute;
  position: relative;
  margin: 0;
  font-family: "Lato";
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
`;

export const DeleteSpan = styled.span`
  border-radius: 40px;
  width: auto;
  margin-left: 7px;
`;

export const DocumentDropdown = styled.div`
  background: #fff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  max-width: 10rem;
  padding: 10px 0;
  position: absolute;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    -webkit-transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 999;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  right: 0;
  left: 65%;
  float: none;
  z-index: 999999999;
`;

export const NoDocument = styled.label`
  width: auto;
  color: #767676;
  font-family: "Lato";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 1;
  text-align: center;
  text-align: left;
  padding: 15px;
`;
